import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import {
  Pane,
  Position,
  Button,
  MenuIcon,
  HomeIcon,
  PersonIcon,
  BoxIcon,
  ShopIcon,
  DollarIcon,
  BankAccountIcon,
  DrawIcon,
  PercentageIcon,
  HelpIcon,
  ChartIcon,
  Dialog,
  Heading
} from 'evergreen-ui';
import logo from '../../assets/images/logo-orange.png';

function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const baseRoute = location.pathname.split('/')[1] || 'dashboard';

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const handleRoute = route => {
    navigate(route);
    setIsOpen(false);
  };

  if (!isMobile) {
    return null; // Don't render on desktop
  }

  const menuItems = [
    { route: '/dashboard', icon: HomeIcon, label: 'Home' },
    { route: '/products', icon: DrawIcon, label: 'Products' },
    { route: '/orders', icon: BoxIcon, label: 'Orders' },
    { route: '/customers', icon: ShopIcon, label: 'Customers' },
    { route: '/creators', icon: PersonIcon, label: 'Creators' },
    { route: '/royalties', icon: PercentageIcon, label: 'Royalties' },
    { route: '/royaltypayments', icon: DollarIcon, label: 'Payments' },
    { route: '/expenses', icon: BankAccountIcon, label: 'Expenses' },
    { route: '/reporting', icon: ChartIcon, label: 'Reporting' },
    { route: '/help', icon: HelpIcon, label: 'Help' }
  ];

  return (
    <>
      <Pane
        position="fixed"
        top={0}
        left={0}
        right={0}
        height={48}
        background="var(--maroon)"
        display="flex"
        alignItems="center"
        paddingX={16}
        zIndex={10}
      >
        <Heading size={500} color="white" marginRight={16}>WorkingLit</Heading>
        <Button
          appearance="minimal"
          height={32}
          iconBefore={MenuIcon}
          onClick={() => setIsOpen(true)}
          color="white"
        >
          Menu
        </Button>
      </Pane>

      <Dialog
        isShown={isOpen}
        title="Navigation"
        onCloseComplete={() => setIsOpen(false)}
        hasFooter={false}
        topOffset="0px"
        sideOffset="0px"
        preventBodyScrolling
      >
        <Pane>
          {menuItems.map(({ route, icon: Icon, label }) => (
            <Pane
              key={route}
              className={route.substring(1) === baseRoute ? 'mobile-nav-item-selected' : 'mobile-nav-item'}
              onClick={() => handleRoute(route)}
              display="flex"
              alignItems="center"
              padding={12}
              marginY={4}
              cursor="pointer"
              borderRadius={4}
            >
              <Icon size={20} marginRight={12} color="var(--maroon)" />
              {label}
            </Pane>
          ))}
        </Pane>
      </Dialog>
    </>
  );
}

export default MobileNav;
